const { assign } = Object;

const toc = require("./toc-tree.js");

const section2RouteParam = {
    "edition": "edition",
    "archive": "archiv",
    "projects": "projekte",
    "search": "suche",
    "watchlist": "merkliste"
};

const routeParam2Section = {
    "edition": "edition",
    "archiv": "archive",
    "projekte": "projects",
    "suche": "search",
    "merkliste": "watchlist"
};

function recursiveUniqueFacsimiles(rootNode, bundle, idHashes) {
    if(!Array.isArray(bundle)) throw "Make sure that the bundle-argument of 'recursiveFacsimiles' is an array";

    for (const f of rootNode.facsimiles) {
        if (!idHashes[f.id]){
            idHashes[f.id] = true;
            f.title = rootNode.title;
            bundle.push(f);
        }
    }
    if (rootNode.contents) {
        for(const n of rootNode.contents) {
            recursiveUniqueFacsimiles(n, bundle, idHashes);
        }
    }
}

function facsimileBundle( { name, params }) {
    const sectionAndId = getSectionAndId( { name, params });
    const node = toc.facsimileBundle(sectionAndId.section, sectionAndId.id);
    const bundle = [];
    const idHashes = {};
    recursiveUniqueFacsimiles(node, bundle, idHashes);
    return { bundle, title: node.title };
}

function getSectionAndId({ name, params }) {
    let section = null, id = null;

    switch (name) {
    case "transcript":
        section = routeParam2Section[params.section];
        id = params.id;
        break;
    }

    if (!id) {
        return null;
    } else {
        return { section, id };
    }
}

function node({ name, params }) {
    const sectionAndId = getSectionAndId( { name, params });

    if(sectionAndId) {
        return toc.node(sectionAndId.section, sectionAndId.id);
    } else {
        return null;
    }
}

module.exports = {
    facsimileBundle,
    node,
    toc,

    fromRoute({ name, params }) {
        const sectionAndId = getSectionAndId( { name, params });

        if (sectionAndId) {
            if (sectionAndId.section === "search" || sectionAndId.section === "watchlist") {
                return assign(
                    { route: { name, params }, ...sectionAndId },
                    toc.node("edition", sectionAndId.id)
                );
            } else {
                return assign(
                    { route: { name, params }, ...sectionAndId },
                    toc.node(sectionAndId.section, sectionAndId.id)
                );
            }
        } else {
            return null;
        }
    },

    data({ section }) {
        section = routeParam2Section[section];
        return toc.data[section];
    },

    routeParamToSection( section ) {
        return routeParam2Section[section];
    },

    sectionHasPage({ section, page }) {
        return node({name: "transcript", params: { section, id: page }}) != null;
    },

    toRoute({component, section, id}) {
        section = section2RouteParam[section];
        return { name: component, params: { id, section }};
    }

};
